import React from 'react';
import { Users, Brain, Clock } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';
export function Failures() {
  const {
    t
  } = useLanguage();
  const icons = [<Users className="w-6 h-6 text-muted" data-id="element-13" />, <Brain className="w-6 h-6 text-muted" data-id="element-14" />, <Clock className="w-6 h-6 text-muted" data-id="element-15" />];
  return <section className="py-24 px-6" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <h2 className="font-serif text-4xl md:text-5xl mb-16 text-center" data-id="element-18">
          {t.failures.h2Part1}{' '}
          <span className="italic text-coral" data-id="element-19">{t.failures.h2Italic}</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-20">
          {t.failures.items.map((item, index) => <div key={index} className="p-8 border border-taupe rounded-2xl bg-surface hover:border-coral/30 transition-colors" data-id="element-21">
              <div className="mb-6 bg-cream w-12 h-12 rounded-full flex items-center justify-center border border-taupe" data-id="element-22">
                {icons[index]}
              </div>
              <h3 className="text-xl font-medium mb-4" data-id="element-23">{item.title}</h3>
              <p className="text-ink/70 leading-relaxed" data-id="element-24">{item.desc}</p>
            </div>)}
        </div>

        <p className="text-center text-xl font-serif mt-16 text-ink/90" data-id="element-25">
          {t.failures.closingBefore}
          <span className="italic text-coral" data-id="element-26">{t.failures.closingItalic}</span>
        </p>
      </div>
    </section>;
}